import ActiveOrdersPage from "./ActiveOrdersPage";

export default ActiveOrdersPage;
